<app-modal-window title="Изменение баланса"
                  [actions]="true"
                  [disabledConfirm]="addBalanceForm.invalid"
                  (close)="close()"
                  (confirm)="onSubmit()">
  <form [formGroup]="addBalanceForm" (ngSubmit)="onSubmit()">
    <div class="input-container">
      <div class="amount">
        <mat-form-field appearance="outline">
          <mat-label>Сумма</mat-label>
          <input matInput type="number" id="amount" formControlName="amount"
                 [placeholder]="isGoFast? '100 fast coins = $0.65 ' : '100 coins = $1'">
          <span *ngIf="isGoFast" class="visual-usd">{{this.addBalanceForm.get('amount').value | fastCoinsToDollar}}</span>
        </mat-form-field>
        <mat-form-field class="form-field" appearance="outline">
          <mat-label>Тип баланса</mat-label>
          <mat-select formControlName="type">
            <mat-option *ngFor="let item of walletTypes$ | async" [value]="item.walletType">
              {{ item.title || item.walletType }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>Комментарий</mat-label>
        <input matInput type="text" formControlName="comment">
      </mat-form-field>
    </div>
    <div *ngIf="amount.invalid && (amount.dirty || amount.touched)"
         class="alert alert-danger">
      <mat-error *ngIf="amount.errors.max">
        Максимальная сумма (10.000$) привышена!
      </mat-error>
    </div>
  </form>
</app-modal-window>
